// extracted by css-extract-rspack-plugin
module.exports =  {"AboundPopupwrapper":"gGTn8","heading":"k4lHy","AboundInfoCard":"RzFKg","AboundInfoText":"FHYsg","highlight":"b4DIz","consentCTA":"M90DH"};